// Self-working hero — gallery thumb switcher + selectable bump. Deferred.
(function () {
  document.querySelectorAll('.mm-sw').forEach(function (root) {
    // Gallery thumbnail switching
    var main = root.querySelector('.mm-sw__main-img');
    root.querySelectorAll('.mm-sw__t').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.mm-sw__t').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.dataset.img;
        if (main && main.tagName === 'IMG' && src) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
        }
      });
    });

    // Selectable bump: toggle the extra cart item + swap the CTA price
    var toggle = root.querySelector('[data-mm-bump-toggle]');
    if (!toggle) return;
    var bumpInputs = root.querySelectorAll('[data-mm-bump-id]');
    var priceBase = root.querySelector('[data-mm-price-base]');
    var priceCombined = root.querySelector('[data-mm-price-combined]');
    var ctaLabel = root.querySelector('[data-mm-cta-label]');

    function sync() {
      var on = toggle.checked;
      bumpInputs.forEach(function (el) { el.disabled = !on; });
      if (priceBase) priceBase.hidden = on;
      if (priceCombined) priceCombined.hidden = !on;
      // Swap the button label to the bundle wording while the bump is ticked.
      if (ctaLabel) {
        var next = on ? ctaLabel.getAttribute('data-bundle') : ctaLabel.getAttribute('data-base');
        if (next && ctaLabel.textContent !== next) ctaLabel.textContent = next;
      }
    }
    toggle.addEventListener('change', sync);
    sync();
  });
})();
